"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateOfferQuotes = exports.matchOffers = exports.matchingOffersV2 = exports.matchingOffers = exports.MAX_TRADE_PER_TRANSACTION = exports.REQUIRE_BUMP_PER_TRADE = exports.REQUIRE_ACCOUNT_PER_TRADE = void 0;
exports.REQUIRE_ACCOUNT_PER_TRADE = 2;
exports.REQUIRE_BUMP_PER_TRADE = 1;
exports.MAX_TRADE_PER_TRANSACTION = 6;
function matchingOffers(offersData, tradeAmount) {
    // in-place sort offerData by available amount
    offersData.sort((a, b) => Number(b.availableAmount) - Number(a.availableAmount));
    // return first offer if available amount at first offer accept
    if (offersData[0].availableAmount.gte(tradeAmount)) {
        return [offersData[0]];
    }
    let start = 0;
    let end = offersData.length - 1;
    while (start < end) {
        const availableAmounts = offersData[start].availableAmount.add(offersData[end].availableAmount);
        if (availableAmounts.gte(tradeAmount)) {
            return [offersData[start], offersData[end]];
        }
        start += 1;
    }
    return [];
}
exports.matchingOffers = matchingOffers;
function matchingOffersV2(offersData, tradeAmount) {
    // in-place sort offerData by available amount
    offersData.sort((a, b) => Number(b.availableAmount) - Number(a.availableAmount));
    // return first offer if available amount at first offer accept
    let remainAmount = tradeAmount;
    const offers = [];
    for (const offerData of offersData) {
        if (offerData.availableAmount.gte(remainAmount)) {
            offers.push(offerData);
            break;
        }
        offers.push(offerData);
        remainAmount = remainAmount.sub(offerData.availableAmount);
    }
    return offers;
}
exports.matchingOffersV2 = matchingOffersV2;
function matchOffers(offersData, tradeAmount) {
    // in-place sort offerData by available amount
    offersData.sort((a, b) => Number(b.availableAmount) - Number(a.availableAmount));
    let totalAmount = 0;
    const offers = [];
    for (const offerData of offersData) {
        if (totalAmount >= Number(tradeAmount)) {
            break;
        }
        offers.push(offerData);
        totalAmount += Number(offerData.availableAmount);
    }
    return offers;
}
exports.matchOffers = matchOffers;
function validateOfferQuotes(offerQuote) {
    if (offerQuote.tradeIds.length != offerQuote.offerQuantity) {
        throw new Error(`Not Enough trade id for ${offerQuote.offerQuantity} trades`);
    }
    if (offerQuote.bumps.length != offerQuote.offerQuantity * exports.REQUIRE_BUMP_PER_TRADE) {
        throw new Error(`Not Enough bumps for ${offerQuote.offerQuantity} trades`);
    }
    if (offerQuote.remainingAccounts.length != offerQuote.offerQuantity * exports.REQUIRE_ACCOUNT_PER_TRADE) {
        throw new Error(`Not Enough vault account for ${offerQuote.offerQuantity} trades`);
    }
}
exports.validateOfferQuotes = validateOfferQuotes;
